import { render, staticRenderFns } from "./StudentForceChangePassword.vue?vue&type=template&id=19acb123&scoped=true&lang=pug&"
import script from "./StudentForceChangePassword.vue?vue&type=script&lang=ts&"
export * from "./StudentForceChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./StudentForceChangePassword.vue?vue&type=style&index=0&id=19acb123&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19acb123",
  null
  
)

export default component.exports